module.exports = __webpack_public_path__ + "static/media/lt.7c29e256.png";